<div class="close-btn" (click)="onConfirmClick()">
    <img src="../../../../assets/images/smallclose.svg" />
</div>
<mat-dialog-content>
    <div class="document-icon-container"><img mat-card-image class="document-icon" src="../../../../assets/images/document-icon.svg" alt="Photo"></div>
    <div class="bil-font-regular document-label">
        The Memorandum of Association or MOA is the legal document that has to be filed with the registrar of companies
        at the time of incorporation of the company.
    </div>
</mat-dialog-content>
